import axios from 'axios';
import { useTranslation } from 'react-i18next';
import { Dispatch, FormEvent, SetStateAction, useState } from 'react';
import ReactCodeInput from 'react-code-input';
import { useDispatch, useSelector } from 'react-redux';
import Spinner from '../../components/common/Spinner';
import {
  ErrorToast,
  SuccessToast
} from '../../components/common/Toasts/Toasts';
import {
  Button,
  Flexed,
  SecurityCodeWrapper
} from '../../styles/GlobalComponents';
import { color } from '../../styles/GlobalStyles';

import { disableVerificationStatus } from './Settings.actions';

import { P2, P3 } from '../../styles/FontStyles';
import { confirmVerification } from './Settings.actions';
import { useAppSelector } from '../../app/hooks';

export const Verification = ({
  setStep,
  setIsOpen
}: {
  setStep: Dispatch<SetStateAction<number>>;
  setIsOpen: Dispatch<SetStateAction<boolean>>;
}) => {
  const { t } = useTranslation('settings');
  const dispatch = useDispatch();
  const [code, setCode] = useState('');
  const [code2Fa, setCode2Fa] = useState('');
  const [loadingCode, setLoadingCode] = useState(false);
  const [isCodeSent, setIsCodeSent] = useState(false);

  const { verificationStatus, loadingVerification } = useAppSelector(
    (state) => state.settings
  );
  const { user } = useAppSelector((state) => state.auth.userInfo);

  const sendCode = async () => {
    try {
      setLoadingCode(true);
      await axios.post(`/user/settings/security/2fa/email/code`, {
        type: verificationStatus ? 1 : 0
      });

      SuccessToast(t('email.code_sent'));
      setLoadingCode(false);
      setIsCodeSent(true);
    } catch (error: any) {
      setLoadingCode(false);
      ErrorToast(error.response.data.error);
    }
  };

  const onHandleSubmit = (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();

    if (verificationStatus) {
      dispatch(
        disableVerificationStatus({ code, twoFACode: code2Fa, setIsOpen })
      );
    } else {
      dispatch(
        confirmVerification({ emailCode: code, twoFACode: code2Fa, setStep })
      );
    }
  };

  return (
    <>
      {loadingCode || loadingVerification ? (
        <Spinner />
      ) : (
        <>
          <form onSubmit={onHandleSubmit}>
            <Flexed between>
              <P2 bold color={color.colors.neutral700}>
                {t('email.email_code')}
              </P2>
              <P2
                bold
                style={{ cursor: 'pointer' }}
                color={color.colors.primary900}
                onClick={() => sendCode()}>
                {t('email.send_code')}
              </P2>
            </Flexed>
            <SecurityCodeWrapper>
              <ReactCodeInput
                name='email code'
                inputMode='numeric'
                fields={7}
                value={code}
                onChange={setCode}
                type={'number'}
              />
            </SecurityCodeWrapper>
            <P3 color={color.colors.neutral500} mb='40'>
              {isCodeSent && `${t('email.enter_7_digit_code')} ${user?.email}`}
            </P3>

            <div>
              <Flexed between>
                <P2 bold color={color.colors.neutral700}>
                  {t('email.2fa_verification_code')}
                </P2>
              </Flexed>
              <SecurityCodeWrapper is2Fa>
                <ReactCodeInput
                  name='email code'
                  inputMode='numeric'
                  fields={6}
                  value={code2Fa}
                  onChange={setCode2Fa}
                  type={'number'}
                />
              </SecurityCodeWrapper>
              <P3 color={color.colors.neutral500} mb='10'>
                {t('email.enter_6_digit_code')}
              </P3>
            </div>

            <Button m='30px 0 10px 0' disabled={code === '' ? true : false}>
              {t('email.confirm')}
            </Button>
          </form>
        </>
      )}
    </>
  );
};
